import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.trabalhadorbackup.cadastra(payload).then(res => {
        dispatch('ActionSetListaTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetListaTrabalhador',err)
    })
}


export const ActionSetListaTrabalhador = ({commit},payload) =>{
    commit(types.SET_TRABALHADOR,payload)
}


